import React, { useEffect, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Form, Grid } from 'semantic-ui-react';
import { FormFields } from '~/components/FormFields';

const Newsletter = (props: any) => {
  const { control, setValue } = useFormContext();
  const { t } = useTranslation();
  const { suffixOptions } = props;
  const [suffixOptionsArray, setSuffixOptionsArray] = useState([]);
  const watchNewsletterEmail = useWatch({ control, name: 'newsletterEmail' });
  const prefix = watchNewsletterEmail.split('@')[0];
  const suffix = watchNewsletterEmail.split('@')[1];
  const hasSuffix = suffixOptions.find((emailSuffix) => emailSuffix.value === suffix) !== undefined;

  const watchEmail = useWatch({ control, name: 'email' });
  const emailPrefix = watchEmail.split('@')[0];
  const emailSuffix = watchEmail.split('@')[1];

  useEffect(() => {
    if (!hasSuffix) {
      setSuffixOptionsArray([
        ...suffixOptions,
        {
          value: suffix,
          text: suffix
        }
      ]);
    } else {
      setSuffixOptionsArray(suffixOptions)
    }
  }, [suffixOptions]);

  return (
    <>
      <div style={{ marginBottom: '2rem' }}>
        <h2>{t('Newsletter')}</h2>
        <Grid columns={3}>
          <Grid.Column>
            <Form.Input
              value={prefix}
              error={prefix === ''}
              onChange={(e, data) => setValue('newsletterEmail', `${data.value}@${suffix}`)}
              label={t('Prefix')}
            />
            <FormFields.Input
              control={control}
              name='newsletterEmailFromName'
              label={t('Sender email')}
            />
          </Grid.Column>
          <Grid.Column>
            <FormFields.Input
              disabled
              value={suffix}
              control={control}
              name='newsletterEmail'
              label={t('Sender email address')}
              style={{ opacity: 1 }}
            />
          </Grid.Column>
          <Grid.Column>
            <div>
              <Form.Select
                label={t('Suffix')}
                value={suffix}
                options={suffixOptionsArray || []}
                onChange={(e, data) => setValue('newsletterEmail', `${prefix}@${data.value}`)}
              />
            </div>
          </Grid.Column>
        </Grid>
      </div>

      <h2>{t('Email')}</h2>
      <Grid columns={3}>
        <Grid.Column>
          <Form.Input
            error={emailPrefix === ''}
            value={emailPrefix}
            onChange={(e, data) => setValue('email', `${data.value}@${emailSuffix}`)}
            label={t('Prefix')}
          />
          <FormFields.Input control={control} name='emailFromName' label={t('Sender email')} />
        </Grid.Column>
        <Grid.Column>
          <FormFields.Input
            disabled
            value={emailSuffix}
            control={control}
            name='email'
            label={t('Sender email address')}
            style={{ opacity: 1 }}
          />
        </Grid.Column>
        <Grid.Column>
          <div>
            <Form.Select
              label={t('Suffix')}
              value={emailSuffix}
              options={suffixOptionsArray}
              onChange={(e, data) => setValue('email', `${emailPrefix}@${data.value}`)}
            />
          </div>
        </Grid.Column>
      </Grid>
    </>
  );
};

export default Newsletter;
